import { SelectedQuestion } from '../../components/Modals/AddSurveyModal/addSurveyInterface';
import apiFetch from '../apiFetch';
import generateHeaders from '../myHeaders';

const updateSurveyContent = (
    surveyId: number,
    selectedQuestions: SelectedQuestion[],
    selectedFilters: SelectedQuestion[],
    selectedSchema: string,
): Promise<unknown> => {
    const payload = { selectedQuestions, selectedFilters };

    return apiFetch(
        `${process.env.REACT_APP_API_URL}/configuration/surveys/${surveyId}/content`,
        { method: 'PUT', headers: generateHeaders(selectedSchema), body: JSON.stringify(payload) },
    );
};

export default updateSurveyContent;
